/**
 * Stub: StoretextOverallCard is not available in the admin app.
 * This stub exists so that @a7y/ui EngineDetailStoretext can be resolved by the bundler.
 */
export const StoretextOverallCard = () => null;
